export const ROLES = {
    VISITOR: 'visitor',
    USER: 'user',
    ADMIN: 'admin',
    MANAGER: 'manager',
    PARTNER : 'partner'
  } as const;
  

export type Role = typeof ROLES[keyof typeof ROLES];

export const ROLE_LABELS_FR: Record<Role, string> = {
  [ROLES.VISITOR]: "Visiteur",
  [ROLES.USER]: "Utilisateur",
  [ROLES.PARTNER]: "Partenaire",
  [ROLES.MANAGER]: "Gestionnaire",
  [ROLES.ADMIN]: "Administrateur",
};

export const rolesAdmin = [ROLES.ADMIN];
export const rolesPartner = [ROLES.PARTNER];
export const rolesStaff = [ROLES.ADMIN, ROLES.MANAGER, ROLES.PARTNER];